// biome-ignore lint/suspicious/noShadowRestrictedNames: Symbol is a domain component name
import { Symbol } from '@lib/images'
import { Button } from '@octopus-do/octopus-storybook'
import type React from 'react'

import css from './Empty.module.scss'

type Props = {
  /** The "Create symbol" button: the first symbol goes to this list. */
  onCreate: () => void
  disabled?: boolean
}

/** The empty symbols tab, the same for the project and for the library. */
const Empty: React.FC<Props> = ({ onCreate, disabled = false }) => (
  <div className={css.container}>
    <div className={css.icon}>
      <Symbol />
    </div>

    <div className={css.description}>
      Symbols help to create and manage consistent blocks across pages.
    </div>

    <div className={css.button}>
      <Button
        priority="secondary"
        size="medium"
        label="Create symbol"
        disabled={disabled}
        onClick={onCreate}
      />
    </div>
  </div>
)

export default Empty
